import {API_ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {normalize, schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'

export const notificationSchema = new schema.Entity(
    'notifications',
    {},
    {
        idAttribute: 'id',
    }
)
export const notification_getReminderOnTime_Api = {
    backend: `Route::get('notifications/get-reminders', 'NotificationController@getReminderOnTime');`,
    root: API_ROOT_URL,
    path: '/notifications/get-reminders',
    method: 'GET',
}

// Route::get('notifications/gets', 'NotificationController@index');
export const notification_get_Api = {
    backend: `// Route::get('notifications/gets', 'NotificationController@index');`,
    root: API_ROOT_URL,
    path: '/notifications/gets',
    method: 'GET',
    schema: notificationSchema,
    transform: createListTransform(notificationSchema),
}

export const notification_markAsRead_Api = {
    backend: `// Route::get('notifications/notification/{no_id}/read', 'NotificationController@markAsRead');`,
    root: API_ROOT_URL,
    path: '/notifications/notification/:no_id/read',
    method: 'POST',
    // Backend giờ trả {data: <notification>, owner: <user>} (giống notification_markAllAsRead_Api)
    // thay vì trả thẳng notification ở top-level - trước đây dùng createTransform(notificationSchema)
    // mặc định (chỉ đọc response.data làm entity) nên KHÔNG patch được count_notifications vào
    // entities.users, khiến badge chuông không giảm khi bấm đọc 1 notification lẻ (chỉ "đọc tất cả"
    // mới giảm đúng) - bug đã phát hiện khi rà lại list notification, sửa transform ở đây cho khớp
    // response mới + đồng bộ đúng cách markAllAsRead đang làm.
    transform: (response) => {
        const item = _.get(response, 'data.data')
        const {result, entities} = normalize(item, notificationSchema)
        const count_notifications = _.get(
            response,
            'data.owner.count_notifications',
            0
        )
        const username = _.get(response, 'data.owner.username')
        return {
            response,
            result,
            entities: {
                ...entities,
                users: {
                    [username]: {
                        count_notifications: count_notifications,
                    },
                },
            },
        }
    },
}

export const notification_markAllAsRead_Api = {
    backend: `Route::get('notifications/mark-all-as-read', 'NotificationController@markAllAsRead');`,
    root: API_ROOT_URL,
    path: '/notifications/mark-all-as-read',
    method: 'POST',
    transform: (response) => {
        const list = _.get(response, 'data.data', [])
        const {result, entities} = normalize(list, [notificationSchema])
        const count_notifications = _.get(
            response,
            'data.owner.count_notifications',
            0
        )
        const username = _.get(response, 'data.owner.username')
        return {
            response,
            result,
            entities: {
                ...entities,
                users: {
                    [username]: {
                        count_notifications: count_notifications,
                    },
                },
            },
        }
    },
}

// Route::get('notifications/notification/{no_id}/unfollow', 'NotificationController@unFollow');
